module.exports = new __parcel__URL__("no-results-light.5ca83755.svg").toString();